import moment from "moment/moment";

export default class DateService {
    static parseAndAutoCompleteDate(value) {
        if (!value) {
            return null;
        }

        value = value.replace(/[^0-9-/]/g, '');

        let newDate = moment(value, 'D-M-YYYY');
        let inFuture = newDate.diff(moment(), 'days') >= 0;

        if (value !== null && value.length < 3 && inFuture === false) {
            newDate.add(1, 'months');
        } else if (value !== null && value.length < 6 && inFuture === false) {
            newDate.add(1, 'years');
        }

        if (newDate.isValid()) {
            return newDate.format('DD-MM-YYYY');
        }

        return '';
    }
}
